export default __webpack_public_path__ + "static/media/3-1-3.eaf99ae1.webp";